/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { createSelector } from 'reselect';

import { selectOrg } from '@nebula/airglow-plugin-unified-shell/dist/selectors';

import getEnv from '../../casing/env';

import {
  selectSessionValidationPluginSettings,
  selectUserValidationPluginSettings,
  selectOrgValidationPluginSettings
} from '../../common/selectors';

export const selectValidationPluginSettings = createSelector(
  selectSessionValidationPluginSettings,
  selectUserValidationPluginSettings,
  selectOrgValidationPluginSettings,
  selectOrg,
  (session = {}, user = {}, org = {}, orgId) => R.pipe(
    R.mergeDeepLeft(user),
    R.mergeDeepLeft(session),
    R.assoc('orgId', orgId),
    R.assoc('env', getEnv())
  )(org)
);
